import type { ChatError } from './shared-types';

export const OPENAI_UNAVAILABLE_STREAM_ERROR_CODE = 'OPENAI_UNAVAILABLE';

type ChatErrorPresentation = Pick<ChatError, 'errorCode' | 'message' | 'type'>;

export function getChatErrorPresentation(error: Error): ChatErrorPresentation {
  if (error.message === OPENAI_UNAVAILABLE_STREAM_ERROR_CODE) {
    return {
      errorCode: OPENAI_UNAVAILABLE_STREAM_ERROR_CODE,
      message:
        "OpenAI is currently experiencing issues, so Nova couldn't complete your request. Please try again shortly.",
      type: 'server',
    };
  }

  const isConnectionError =
    error.message.includes('network') ||
    error.message.includes('fetch') ||
    error.message.includes('Failed to fetch') ||
    error.message.includes('connection');

  return {
    message: isConnectionError
      ? 'Unable to connect. Please refresh the page or check your network connection.'
      : 'Unable to complete your request. Please try again.',
    type: isConnectionError ? 'network' : 'server',
  };
}
